<template>
  <div class="calico-input-page">
    <CalicoChatInputField
      :file="file"
      @upload="handleUpload"
      @trash="file = null"
    />
  </div>
</template>

<script>
import CalicoChatInputField from '@/components/calico/chatInputField/index.vue';

export default {
  name: 'CalicoChatInputFieldPage',
  components: {
    CalicoChatInputField,
  },
  data() {
    return {
      file: null,
    };
  },
  methods: {
    handleUpload(file) {
      if (!file) return;
      this.file = {
        name: file.target.files[0].name,
        progress: 0,
        completed: false,
        error: false,
        message: ''
      };
    }
  }
};
</script>

<style lang="scss">
  .calico-input-page {
    @include stack-space($space-large);
    justify-content: center;
    margin: auto;
    width: 50%;
    height: 500px;
  }
</style>